import { render, staticRenderFns } from "./Variant_information.vue?vue&type=template&id=067a4c46&scoped=true"
import script from "./Variant_information.vue?vue&type=script&lang=js"
export * from "./Variant_information.vue?vue&type=script&lang=js"
import style0 from "./Variant_information.vue?vue&type=style&index=0&id=067a4c46&prod&lang=scss&parent=true&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a4c46",
  null
  
)

export default component.exports